import React from 'react';
import { Text, TextProps } from '@chakra-ui/react';

export const IndicatesRequired = (props: TextProps) => (
  <Text textStyle="label" color="blackAlpha.350" {...props}>
    * indicates required
  </Text>
);
